import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom"
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import Footer from "../components/footer";
import Header, { AuthKey, AdminKey } from "../components/header";

export default function Admin() {
    const navigate = useNavigate();
    const adminKey = new URLSearchParams(useLocation().search)?.get('zxcv');
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check if the user is an admin
        if (adminKey !== AdminKey)
            navigate('/');

        async function getOrders() {
            // Call the lambda to get the orders
            await fetch("https://7xy9woipl7.execute-api.us-west-2.amazonaws.com/prod/getOrders?marker=" + AuthKey, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: '',
            })
            .then((res) => res.json())
            .then((data) => {
                setOrders(data);
                setLoading(false);
            });
        }
        if (orders.length === 0) {
            getOrders();
        }
    }, [orders, loading, adminKey, navigate]);

    if (loading)
        return (adminKey === AdminKey && <HelmetProvider>
            <Helmet title="Order Administration"/>
            <Header />
            <Box className="mainBox">
                <Box className="subMainBox">
                    <h1>Orders</h1>
                    <h3>Loading....</h3>
                </Box>
            </Box>
            <Footer />
        </HelmetProvider>);

    return (adminKey === AdminKey && <HelmetProvider>
        <Helmet title="Order Administration"/>
        <Header />
        <Box className="mainBox">
        <Box className="subMainBox">
            <div style={{ display: "flex", alignItems: "center"}}>
            <h1>Orders</h1>
                <a style={{ margin: "0 0 0 20px"}} href={'/ordercontents?year=2022&zxcv=' + adminKey}>2022 Orders</a><br/>
                <a style={{ margin: "0 0 0 20px"}} href={'/ordercontents?year=2023&zxcv=' + adminKey}>2023 Orders</a><br/>
                <a style={{ margin: "0 0 0 20px"}} href={'/ordercontents?year=2024&zxcv=' + adminKey}>2024 Orders</a><br/>
                <a style={{ margin: "0 0 0 20px"}} href={'/ordercontents?year=2025&zxcv=' + adminKey}>2025 Orders</a><br/>
            </div>
            <Table size='small'>
                <TableHead  sx={{ fontWeight: "bold", backgroundColor: "#a0a0a0" }}>
                    <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Packing Slip</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Ship It</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Order Number</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Status</TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold", padding: "10px"}}>Date</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Customer</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>State</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Total</TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold", padding: "10px"}}>Items</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* Sort the orders by date descending */}
                    {orders.sort((a,b) => b.orderDate - a.orderDate).map((row, index) => {
                        return (
                        <TableRow hover key={index}>
                            <TableCell align="center" sx={{ fontSize: "1.0em", padding: "0px"}}>
                                <Button variant="outlined" size="small" sx={{ margin: "5px" }} disabled={row.status === "shipped"}
                                        onClick={() => window.open("packingslip?orderId=" + row.orderId + "&zxcv=" + adminKey, "_blank")}>Packing Slip</Button>
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: "1.0em", padding: "0px"}}>
                                <Button variant="outlined" size="small" sx={{ margin: "5px" }} disabled={row.status === "shipped"}
                                        onClick={() => window.open("shipit?orderId=" + row.orderId + "&zxcv=" + adminKey, "_blank")}>Ship It</Button>
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{row.orderId}</TableCell>
                            <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{row.status}</TableCell>
                            <TableCell align="center" sx={{ fontSize: "1.0em", padding: "10px"}}>{new Date(row.orderDate).toLocaleString()}</TableCell>
                            <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>{row?.customer?.name.substr(0, 20)}</TableCell>
                            <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>{row?.customer?.state}</TableCell>
                            <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>
                                {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(row?.total / 100)}
                            </TableCell>
                            <TableCell align="left" sx={{ fontSize: "1.0em", padding: "10px"}}>{row?.items?.length}</TableCell>
                        </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
            </Box>
        </Box>
        <Footer />
    </HelmetProvider>);
}